var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLupe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8164 19.9336L15.2891 14.4063C16.5078 12.9844 17.2149 11.1445 17.2149 9.125C17.2149 4.63672 13.577 1 9.08985 1C4.60274 1 1 4.63789 1 9.125C1 13.6121 4.63751 17.25 9.08985 17.25C11.1086 17.25 12.9512 16.5094 14.3711 15.291L19.8984 20.8184C20.0547 20.9375 20.2149 21 20.375 21C20.5352 21 20.6949 20.939 20.8168 20.8169C21.0625 20.5742 21.0625 20.1758 20.8164 19.9336ZM9.12501 16C5.30079 16 2.25001 12.9141 2.25001 9.125C2.25001 5.33594 5.30079 2.25 9.12501 2.25C12.9492 2.25 16 5.30078 16 9.125C16 12.9492 12.9141 16 9.12501 16Z",
    fill: "#203464"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLupe);
export default __webpack_public_path__ + "static/media/lupe.496bcf6cb710d628589464667a46162d.svg";
export { ForwardRef as ReactComponent };